import { runtimeConfig } from './runtime';

type SafeLinkSurface = 'internal' | 'legal' | 'external';

type SafeLinkRuntimeContext = {
  appOrigin?: string;
  isNativePlatform?: boolean;
};

export type SafeLinkAttributes = {
  target?: '_blank';
  rel?: 'noopener noreferrer';
};

const newContextAttributes: SafeLinkAttributes = Object.freeze({
  target: '_blank',
  rel: 'noopener noreferrer',
});

const resolveUrl = (
  href: string,
  appOrigin: string
): URL | null => {
  try {
    return new URL(href, `${appOrigin}/`);
  } catch {
    return null;
  }
};

const isHttpUrl = (url: URL): boolean => url.protocol === 'http:' || url.protocol === 'https:';

export const shouldOpenSafeLinkInNewContext = (
  href: string,
  surface: SafeLinkSurface = 'internal',
  context: SafeLinkRuntimeContext = runtimeConfig
): boolean => {
  const appOrigin = context.appOrigin || runtimeConfig.appOrigin;
  const url = resolveUrl(href, appOrigin);

  if (!url || !isHttpUrl(url)) {
    return false;
  }

  if (surface === 'external') {
    return true;
  }

  if (surface === 'legal' && context.isNativePlatform) {
    return true;
  }

  return url.origin !== appOrigin;
};

export const getSafeLinkAttributes = (
  href: string,
  surface: SafeLinkSurface = 'internal',
  context: SafeLinkRuntimeContext = runtimeConfig
): SafeLinkAttributes =>
  shouldOpenSafeLinkInNewContext(href, surface, context)
    ? newContextAttributes
    : {};
